import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { MoveShiftsResponse } from '@wilson/api/gateway';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import {
  Activity,
  RoleAction,
  RolePermissionSubject,
  Shift,
} from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AssignSingleShiftActionComponent } from '../assign-single-shift-action/assign-single-shift-action.component';
import { ConvertToStandbyShiftActionComponent } from '../convert-to-standby-shift-action/convert-to-standby-shift-action.component';
import { DeleteShiftActionComponent } from '../delete-shift-action/delete-shift-action.component';
import { DuplicateShiftActionComponent } from '../duplicate-shift-action/duplicate-shift-action.component';
import { ExportShiftActionComponent } from '../export-shift-action/export-shift-action.component';
import { FillWithPlannedTimeActionComponent } from '../fill-with-planned-time-action/fill-with-planned-time-action.component';
import { MoveSingleShiftActionComponent } from '../move-single-shift-action/move-single-shift-action.component';
import { SaveAsTemplateActionComponent } from '../save-as-template-action/save-as-template-action.component';

@Component({
  selector: 'wilson-more-shift-actions-dropdown',
  imports: [
    CommonModule,
    ExportShiftActionComponent,
    NzButtonModule,
    NzDropdownModule,
    TranslatePipe,
    NzIconModule,
    FeatureFlagsModule,
    ConvertToStandbyShiftActionComponent,
    DeleteShiftActionComponent,
    SaveAsTemplateActionComponent,
    FillWithPlannedTimeActionComponent,
    NzTooltipModule,
    DuplicateShiftActionComponent,
    MoveSingleShiftActionComponent,
    AssignSingleShiftActionComponent,
    NzTooltipModule,
    FontAwesomeModule,
  ],
  templateUrl: './more-shift-actions-dropdown.component.html',
  styleUrl: './more-shift-actions-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreShiftActionsDropdownComponent {
  @Input({
    required: true,
  })
  shift!: Shift & { activities: Activity[] };
  @Input({
    required: true,
  })
  disableSaveAsTemplate = false;

  @Input()
  duplicateShiftInNewTab = false;

  @Input()
  isMoveAllowed = false;

  @Input()
  renderMoveOption = false;

  @Input()
  renderAssignShift = false;

  @Input()
  disableAssignShift = false;

  @Input() disabled = false;

  @Input()
  showIconOnly = false;
  @Output()
  convertShiftToStandbySuccessful = new EventEmitter<Shift>();

  @Output()
  filledShiftWithPlannedTimeSuccessful = new EventEmitter();

  @Output()
  deleteTriggered = new EventEmitter();

  @Output() moveShiftSuccess = new EventEmitter<MoveShiftsResponse>();

  @Output()
  assignShiftSuccess = new EventEmitter();

  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  can = inject(AbilityServiceSignal).can;
  readonly faEllipsis = faEllipsis;
}
